

































































































import Vue from 'vue'
import SectionTitle from '@/components/SectionTitle.vue'
import TabSecond from '@/components/TabSecond.vue'
const PlatformCollect = Vue.extend({
  components: {
    SectionTitle,
    TabSecond
  },
  data () {
    return {
      curIndex: 0
    }
  },
  methods: {
    selectCollect (e: number) {
      this.curIndex = e
    }
  }
})
export default PlatformCollect
